<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div>
          <button type="button" (click)="showBusinessRuleType()" id="btn_AddNew" style="display:none">Add</button>
          <button type="button" id="btnDeleteBusinessRule" (click)="deleteBusinessRuleType()" style="display:none">Delete Business Rule Type</button>
          <button type="button" id="btnDeleteDT" (click)="Deleteconfirmation()" style="display:none">Delete Business Rule Type</button>
          <table #dataTable class="display" style="width:100%"></table>
        </div>
        <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-md custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title"> {{title}} </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <!--Loader gif-->
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>

              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    <label>Rule Type</label>
                    <input id="Txt_RuleType" type="text" class="form-control" maxlength="225" autocomplete="off" />
                  </div>&nbsp;
                  <div class="col-sm-12">
                    <label>Prefix</label>
                    <input id="Txt_Prefix" type="text" class="form-control" maxlength="5" autocomplete="off" />
                  </div>&nbsp;
                  <div class="col-sm-12">
                    <label>Start Rule No</label>
                    <input id="Txt_StartRuleNo" type="number" min="0" class="form-control" autocomplete="off" />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="submit" (click)="UpdateBusinessRuleType()" class="btn btn-outline-success waves-effect waves-light">{{popupButtonText}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
